export default __webpack_public_path__ + "static/media/lumix-2020-g100v-galleryimages-5-210129.891d84d7.jpg";